export async function encryptContents(dek: CryptoKey, contents: BufferSource) {
  const iv = crypto.getRandomValues(new Uint8Array(12)); // 12 bytes for AES-GCM
  const cipherText = await crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv: iv,
    },
    dek,
    contents
  );

  const combined = new Uint8Array(iv.byteLength + cipherText.byteLength);
  combined.set(iv);
  combined.set(new Uint8Array(cipherText), iv.byteLength);
  return combined;
}

export async function decryptContents(dek: CryptoKey, encryptedContents: ArrayBufferLike | Uint8Array) {
  const tmp = encryptedContents instanceof Uint8Array ? encryptedContents : new Uint8Array(encryptedContents);
  const iv = tmp.slice(0, 12);
  const cipherText = tmp.slice(12);

  return await crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv: iv,
    },
    dek,
    cipherText
  );
}
